<template>
  <div class="flex flex-col" :class="props.size">
    <p class="font-bold">State</p>
    <Select
      :inputId="props.name"
      :name="props.name"
      :options="states"
      placeholder="Select a state"
      class="w-full h-10"
      showClear
      v-model="value"
    ></Select>
  </div>
</template>

<script setup lang="ts">
import { useField } from "vee-validate";

interface Props {
  name: string;
  size?: string;
  required?: boolean;
}
const props = withDefaults(defineProps<Props>(), {
  size: "w-full",
  required: false,
});

const { value, errorMessage } = useField(() => props.name);

const states = [
  "AL",
  "AK",
  "AR",
  "AZ",
  "CA",
  "CO",
  "CT",
  "DE",
  "FL",
  "GA",
  "HI",
  "IA",
  "ID",
  "IL",
  "IN",
  "KS",
  "KY",
  "LA",
  "MA",
  "MD",
  "ME",
  "MI",
  "MN",
  "MO",
  "MS",
  "MT",
  "NC",
  "ND",
  "NE",
  "NH",
  "NJ",
  "NM",
  "NV",
  "NY",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VA",
  "VT",
  "WA",
  "WI",
  "WV",
  "WY",
];
</script>
